__turbopack_export_value__({
  "pagination": "Pagination-module-scss-module__gKVc0G__pagination",
  "pagination__dots": "Pagination-module-scss-module__gKVc0G__pagination__dots",
  "pagination__page": "Pagination-module-scss-module__gKVc0G__pagination__page",
  "pagination__page_selected": "Pagination-module-scss-module__gKVc0G__pagination__page_selected",
  "pagination__pages": "Pagination-module-scss-module__gKVc0G__pagination__pages",
});
